module.exports = __webpack_public_path__ + "static/media/ecommerce-img-m-02.966e3042.png";